/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */

import { useOnlineStatusDetector } from './useOnlineStatusDetector';

/* eslint-disable no-await-in-loop */
const { useState } = require('react');
const { useIndexedDB } = require('react-indexed-db-hook');

const customSort = (a, b) => {
  const pattern = /group(\d+)-5/;
  const matchA = a.id.match(pattern);
  const matchB = b.id.match(pattern);

  if (matchA && matchB) {
    const dataA = parseInt(matchA[1], 10);
    const dataB = parseInt(matchB[1], 10);
    return dataA - dataB;
  }

  return 0;
};

export const useOfflineVideoLoader = () => {
  const { add, deleteRecord, getAll, getByIndex } = useIndexedDB('videos');
  const [progress, setProgress] = useState(0);
  // const { isOnline } = useNavigatorStatus();
  const { isOnline } = useOnlineStatusDetector();
  // const [isOnline, setIsOnline] = useState(navigator.onLine);
  // const [offline, setOffline] = useState(!navigator.onLine);
  const { add: addUrl, getAll: getAllVideoUrls } = useIndexedDB('video_url');

  // useEffect(() => {
  //   console.log('useEffect is executing ');
  //   window.addEventListener('online', () => console.log('online'));
  //   window.addEventListener('offline', () => console.log('offline'));
  // }, []);

  const getRecord = async (urlToDownload) => {
    const allUrls = await getAllVideoUrls();

    if (!allUrls.map((obj) => obj.url).includes(urlToDownload)) {
      await addUrl({ url: urlToDownload });
      const allUrlsUpdated = await getAllVideoUrls();
      return allUrlsUpdated.find((obj) => obj.url === urlToDownload);
    }
    return allUrls.find((obj) => obj.url === urlToDownload);
  };

  const downloadVideo = async (objVideo, setDowloadedSize) => {
    const { url } = objVideo;
    const response = await fetch(url);
    const chunkSize = 50000;
    const maxGroupSize = 100 * 1024 * 1024; // Максимальний загальний розмір групи в байтах

    try {
      if (!response.ok) {
        return;
      }

      let totalSize;
      const contentRangeHeader = response.headers.get('Content-Range');
      if (contentRangeHeader) {
        const [, rangeSize] = contentRangeHeader.match(/\/(\d+)/) || [];
        totalSize = rangeSize ? parseInt(rangeSize, 10) : NaN;
      } else {
        totalSize = parseInt(response.headers.get('Content-Length'), 10);
      }

      // if (!Number.isNaN(totalSize) && totalSize > 0) {
      //   console.log('Total size:', totalSize);
      // } else {
      //   console.error('Unable to determine the total size of the video.');
      //   return;
      // }

      let receivedSize = 0;
      let currentGroup = [];
      let currentGroupSize = 0;
      let groupId = 0;

      while (receivedSize < totalSize) {
        const startByte = receivedSize;
        const endByte = Math.min(receivedSize + chunkSize - 1, totalSize - 1);
        const nextResponse = await fetch(url, {
          headers: {
            Range: `bytes=${startByte}-${endByte}`,
          },
        });

        if (!nextResponse.ok) {
          // console.log(
          //   `Failed to fetch video chunk: ${nextResponse.status} ${nextResponse.statusText}`
          // );
          return;
        }

        const nextArrayBuffer = await nextResponse.arrayBuffer();
        const nextChunk = new Uint8Array(nextArrayBuffer);

        currentGroup.push(nextChunk);
        currentGroupSize += nextChunk.length;

        if (
          currentGroupSize >= maxGroupSize ||
          receivedSize + chunkSize >= totalSize
        ) {
          // Store the current group in IndexedDB
          await add({
            id: `group${groupId}-${objVideo.id}`,
            totalSize,
            video: currentGroup,
          });

          // Reset for the next group
          currentGroup = [];
          currentGroupSize = 0;
          groupId += 1;
        }

        receivedSize += nextArrayBuffer.byteLength;
        setDowloadedSize((prev) => prev + nextArrayBuffer.byteLength);
        setProgress(receivedSize);
      }

      // console.log('Download complete. Total size:', totalSize);
    } catch (error) {
      // console.error('Error fetching or processing video:', error);
    }

    const regexPattern = new RegExp(`^group\\d+-${objVideo.id}$`);
    const all = await getAll();
    const fileteredArr = all.filter((el) => regexPattern.test(el.id));
    const sortedArr = fileteredArr.sort(customSort).map((el) => el.video);
    const chunks = [].concat(...sortedArr);
    const combinedChunk = new Uint8Array(fileteredArr[0]?.totalSize);
    let offset = 0;
    for (const chunk of chunks) {
      combinedChunk.set(chunk, offset);
      offset += chunk.length;
    }
    const videoBlob = new Blob([combinedChunk], { type: 'video/mp4' });
    return URL.createObjectURL(videoBlob);
  };

  const deleteVideo = async (url) => {
    const video = await getRecord(url);
    const allRecords = await getAll();
    const neededKeys = allRecords
      .map((elem) => elem.id)
      .filter((item) => item.endsWith(`-${video?.id}`));
    neededKeys.forEach((key) => deleteRecord(key));
  };

  const downloadVideoByUrl = async (video, setSmth) => {
    // get the first video group to see if the downloading ever started
    const videoGroup0InDB = await getByIndex('id', `group0-${video.id}`);
    if (!videoGroup0InDB && isOnline) {
      const lnk = await downloadVideo(video, setSmth);
      return lnk;
    }
  };

  const getOfflineVideoUrl = async (urlToDownload) => {
    const video = await getRecord(urlToDownload);
    if (video) {
      const regexPattern = new RegExp(`^group\\d+-${video.id}$`);
      const all = await getAll();
      const fileteredArr = all.filter((el) => regexPattern.test(el.id));
      const sortedArr = fileteredArr.sort(customSort).map((el) => el.video);
      const chunks = [].concat(...sortedArr);
      const combinedChunk = new Uint8Array(fileteredArr[0]?.totalSize);
      let offset = 0;
      for (const chunk of chunks) {
        combinedChunk.set(chunk, offset);
        offset += chunk.length;
      }
      const videoBlob = new Blob([combinedChunk], { type: 'video/mp4' });
      return URL.createObjectURL(videoBlob);
    }
    return null;
  };

  // rewritten getOfflineVideoUrl while fixing bug with videos
  const getOfflineVideo = async (urlToGet) => {
    const allUrls = await getAllVideoUrls();
    const video = allUrls.find((obj) => obj.url === urlToGet);
    if (!video) return null;

    const regexPattern = new RegExp(`^group\\d+-${video.id}$`);
    const all = await getAll();
    const fileteredArr = all.filter((el) => regexPattern.test(el.id));
    const sortedArr = fileteredArr.sort(customSort).map((el) => el.video);
    const chunks = [].concat(...sortedArr);
    const combinedChunk = new Uint8Array(fileteredArr[0]?.totalSize);
    let offset = 0;
    for (const chunk of chunks) {
      combinedChunk.set(chunk, offset);
      offset += chunk.length;
    }
    const videoBlob = new Blob([combinedChunk], { type: 'video/mp4' });
    return URL.createObjectURL(videoBlob) || null;
  };

  return {
    deleteVideo,
    downloadVideoByUrl,
    getOfflineVideo,
    getOfflineVideoUrl,
    getRecord,
    progress,
  };
};
